import { render } from "./PersonalStatisticsOkrElementsList.vue?vue&type=template&id=44e0d47e&scoped=true"
import script from "./PersonalStatisticsOkrElementsList.vue?vue&type=script&lang=js"
export * from "./PersonalStatisticsOkrElementsList.vue?vue&type=script&lang=js"

import "./PersonalStatisticsOkrElementsList.vue?vue&type=style&index=0&id=44e0d47e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e0d47e"]])

export default __exports__